import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import ImageService from '../../services/ImageService';

class QmImage extends Component {
  constructor(props) {
    super(props);
    this.getImageSource = this.getImageSource.bind(this);

    this.state = {
      imageDidntLoad: false,
      loadedWidth: null,
      loadedHeight: null,
      mouseDelta: null,
      DELTA: 0.1,
      isError: false,
    };
  }

  getImageSource() {
    const { loadedHeight, loadedWidth } = this.state;
    const { src, width, height, options, isFullPath } = this.props;
    let imageOptions = {};

    if (width) {
      imageOptions.w = Math.min(1.7 * Number(width), 2000);
      imageOptions.h = null;
    }

    if (height) {
      imageOptions.h = 1.7 * Number(height);
    }

    imageOptions.dpr = window.devicePixelRatio;
    imageOptions.usm = 15;

    if (options) {
      imageOptions = _.merge({}, imageOptions, options);
    }
    const imageURL = isFullPath
      ? src
      : ImageService().getFull(src, imageOptions);
    if (!loadedHeight && !loadedWidth) {
      const newObject = new Image();
      const listener = () => {
        this.setState({
          loadedWidth: newObject.width,
          loadedHeight: newObject.height,
        });
        newObject.removeEventListener('load', listener);
      };
      newObject.addEventListener('load', listener);
      newObject.src = imageURL;
    }
    return imageURL;
  }

  handleMouseDown = e => {
    this.setState({ mouseDelta: { x: e.pageX, y: e.pageY } });
  };
  handleMouseUp = e => {
    const { onClick } = this.props;
    const { mouseDelta, DELTA } = this.state;

    if (mouseDelta) {
      if (
        Math.abs(mouseDelta.x - e.pageX) < DELTA &&
        Math.abs(mouseDelta.y - e.pageY) < DELTA
      ) {
        onClick ? onClick(e) : null;
      }
    }
  };
  handleImageError = () => {
    this.setState({ isError: true });
  };

  render() {
    const { loadedHeight, loadedWidth, isError } = this.state;

    const {
      className,
      width,
      fullWidth,
      height,
      style,
      fillSpace,
      alt = '',
      title = '',
      cover,
      contain,
      imgStyles,
    } = this.props;

    let finalWidth;
    let finalHeight;
    let spaceContainerStyles = {};
    const spaceStyles = {};
    const BROKEN_IMAGE_PLACEHOLDER_SRC =
      'assets/images/common/broken-image.png';
    if (fillSpace) {
      spaceContainerStyles = {
        overflow: 'hidden',
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
      };
      spaceStyles.position = 'absolute';
      if (loadedHeight < loadedWidth) {
        finalHeight = height;
        spaceContainerStyles.flexDirection = 'row';
      } else {
        finalWidth = width;
        spaceContainerStyles.flexDirection = 'column';
      }
    } else {
      finalHeight = height ? Number(height) : '';
      finalWidth = fullWidth ? '100%' : width ? Number(width) : '';
    }

    if (cover) {
      spaceStyles.objectFit = 'cover';
    }
    if (contain) {
      spaceStyles.objectFit = 'contain';
    }

    return (
      <div
        onMouseDown={this.handleMouseDown}
        onMouseUp={this.handleMouseUp}
        className={`qm-image${className ? ` ${className}` : ''}`}
        style={{ ...style, ...spaceContainerStyles }}
      >
        {!isError ? (
          <img
            draggable={false}
            src={this.getImageSource()}
            width={finalWidth}
            height={finalHeight}
            style={{ ...spaceStyles, ...imgStyles }}
            alt={alt}
            onError={this.handleImageError}
            title={title}
          />
        ) : (
          <img
            draggable={false}
            src={BROKEN_IMAGE_PLACEHOLDER_SRC}
            width={finalWidth}
            height={finalHeight}
            style={{ ...spaceStyles, ...imgStyles }}
            alt={alt}
            title={title}
          />
        )}
      </div>
    );
  }
}

QmImage.defaultProps = {};

QmImage.propTypes = {
  className: PropTypes.string,
  src: PropTypes.string.isRequired,
  width: PropTypes.number,
  height: PropTypes.number,
  options: PropTypes.object,
  style: PropTypes.object,
  fullWidth: PropTypes.bool,
  fillSpace: PropTypes.bool,
  canViewPhoto: PropTypes.bool,
};

export default QmImage;
